export default {
  // Common
  learnMore: 'Læs mere',
  backToFaq: 'Tilbage til FAQ',
  relatedQuestions: 'Relaterede spørgsmål',
  relatedQuestionsTitle: 'Relaterede spørgsmål',
  stillHaveQuestions: 'Har du stadig spørgsmål?',
  contactUsText: 'Kontakt os gerne, så hjælper vi dig videre.',

  // ============ Hvad koster installation af ladeboks ============
  installPriceTitle: 'Hvad koster installation af ladeboks?',
  installPriceSubtitle: 'Installation fra 1.300 kr. til 3.000 kr. – afhængigt af installationstype',
  installIntro1: 'Prisen på installation af ladeboks afhænger af, om du har en <strong>eksisterende installation</strong> eller skal have lagt nyt kabel.',
  installIntro2: 'Nedenfor kan du se de to installationstyper og hvad der er inkluderet i prisen.',
  installOptionsTitle: 'Vælg installationstype',
  existingInstallTitle: 'Eksisterende installation',
  existingInstallPrice: '1.300 kr.',
  fullInstallTitle: 'Komplet installation',
  fullInstallPrice: '3.000 kr.',
  installIncluded1: 'Montering af ladeboks',
  installIncluded2: 'Tilslutning til el-tavle',
  installIncluded3: 'Test og godkendelse',
  installIncluded4: 'Elinstallationsrapport',
  installIncluded5: 'Op til 10 meter kabel',
  installIncluded6: 'Ny gruppe i el-tavle',
  installNote1: 'Til dig, der skal udskifte en eksisterende ladeboks eller har kraftstik. Kabelføringen er allerede på plads.',
  installNote2: 'Længere kabeltræk eller komplekse forhold kan medføre merpris.',
  whatIncludedTitle: 'Hvad er inkluderet?',
  alwaysIncluded: 'Altid inkluderet',
  authorizedElectrician: 'Autoriseret elektriker',
  chargerMounting: 'Montering af ladeboks',
  gridConnection: 'Tilslutning til elnet',
  functionTest: 'Funktionstest',
  walkthrough: 'Gennemgang af brug',
  electricianDoc: 'Elinstallationsrapport',
  mayCoatExtra: 'Kan koste ekstra',
  digging: 'Gravearbejde',
  extraCable: 'Kabel over 10 meter',
  panelUpgrade: 'Opgradering af eltavle',
  standMounting: 'Stander-montering',
  specialCabling: 'Særlig kabelføring',
  factorsTitle: 'Faktorer der påvirker prisen',
  distanceTitle: 'Afstand fra eltavle',
  distanceDesc: 'Jo længere afstand fra eltavlen til ladeboksen, jo mere kabel og arbejde kræves.',
  existingInstallationTitle: 'Eksisterende installation',
  existingInstallationDesc: 'Når du udskifter en eksisterende ladeboks eller har kraftstik ved placeringen, kan den eksisterende kabelføring genbruges.',
  panelCapacityTitle: 'Eltavlens kapacitet',
  panelCapacityDesc: 'Ældre eltavler kan kræve opgradering for at håndtere ladeboksens strømforbrug.',
  complexityTitle: 'Installationens kompleksitet',
  complexityDesc: 'Særlige forhold som gennemboringer, lange kabeltræk eller udendørs montering kan øge prisen.',
  timelineTitle: 'Tidsplan for installation',
  timelineIntro: 'Typisk tager hele processen fra bestilling til færdig installation 1-2 uger:',
  timelineStep1: '<strong>Bestilling:</strong> Du bestiller ladeboks med installation',
  timelineStep2: '<strong>Kontakt:</strong> Elektriker kontakter dig inden for 2-3 dage',
  timelineStep3: '<strong>Aftale:</strong> I aftaler tidspunkt for installation',
  timelineStep4: '<strong>Installation:</strong> Installation tager typisk 2-4 timer',
  timelineNote: 'Ventetid kan variere afhængigt af geografisk placering og efterspørgsel.',
  installFaq1Q: 'Kan jeg bruge min egen elektriker?',
  installFaq1A: 'Ja, du kan sagtens bestille ladeboksen uden installation og bruge din egen autoriserede elektriker.',
  installFaq2Q: 'Hvad hvis jeg har brug for mere end 10 meter kabel?',
  installFaq2A: 'Ved behov for mere end 10 meter kabel vil elektrikeren give dig et tilbud på merprisen inden installationen påbegyndes.',
  installFaq3Q: 'Er der garanti på installationen?',
  installFaq3A: 'Ja, alle installationer udføres af autoriserede elektrikere og er omfattet af reklamationsret.',
  installFaq4Q: 'Hvad hvis min eltavle er for gammel?',
  installFaq4A: 'Elektrikeren vurderer din eltavle og giver besked, hvis opgradering er nødvendig. Du får altid besked om eventuelle ekstraomkostninger inden arbejdet udføres.',
  installCtaTitle: 'Klar til at få installeret din ladeboks?',
  installCtaSubtitle: 'Se vores ladebokse og vælg den installation der passer til dig',
  seeChargersWithInstall: 'Se ladebokse med installation',
  whichChargerToChoose: 'Hvilken ladeboks skal jeg vælge?',
  getHelpChoosing: 'Få hjælp til at vælge den rigtige ladeboks',
  chargerPlusElPackage: 'Ladeboks + elaftale',
  seeCompleteSolutions: 'Se komplette løsninger',

  // ============ Kan jeg købe ladeboks uden elaftale ============
  buyChargerOnlyTitle: 'Kan jeg købe ladeboks uden elaftale?',
  buyChargerOnlySubtitle: 'Ja – køb kvalitets-ladeboks separat, med eller uden installation',
  buyChargerOnlyIntro1: 'Ja, du kan sagtens købe en ladeboks hos enkel energi uden at tegne en elaftale. Vi tilbyder ladebokse fra Zaptec og NexBlue – alle med mulighed for valgfri installation.',
  buyChargerOnlyIntro2: 'Du kan altid tilføje en elaftale senere og få adgang til Saving Mode og andre fordele.',
  whatYouGetTitle: 'Det får du ved køb af ladeboks',
  qualityChargers: 'Kvalitets-ladebokse',
  qualityChargersDesc: 'Alle vores ladebokse er udvalgt for deres kvalitet og driftssikkerhed.',
  optionalInstall: 'Valgfri installation',
  optionalInstallDesc: 'Tilkøb professionel installation eller brug din egen elektriker.',
  warranty5Years: '5 års garanti',
  warranty5YearsDesc: 'Alle vores ladebokse har 5 års producentgaranti.',
  worksWithAll: 'Virker med alle elbiler',
  worksWithAllDesc: 'Type 2 stik der passer til alle moderne elbiler.',
  futureReady: 'Klar til fremtiden',
  futureReadyDesc: 'Alle ladebokse er kompatible med Saving Mode.',
  sharpPrices: 'Skarpe priser',
  sharpPricesDesc: 'Konkurrencedygtige priser på alle vores ladebokse.',
  ourChargers: 'Vores ladebokse',
  popularReliable: 'Populær og pålidelig',
  newestTech: 'Nyeste teknologi',
  affordableQuality: 'Prisvenlig kvalitet',
  whyBuyStandalone: 'Hvorfor købe ladeboks separat?',
  reason1Title: 'Du har allerede en god elaftale',
  reason1Text: 'Hvis du er tilfreds med dit nuværende elselskab, kan du købe ladeboksen separat og beholde din eksisterende aftale.',
  reason2Title: 'Du vil bestemme selv',
  reason2Text: 'Nogle foretrækker at holde elaftale og ladeboks adskilt for at have fuld fleksibilitet.',
  reason3Title: 'Du vil afprøve først',
  reason3Text: 'Køb ladeboksen nu og tilføj Saving Mode og elaftale senere, når du er klar.',
  reason4Title: 'Du har solceller',
  reason4Text: 'Hvis du har solceller og vil optimere din egen produktion, kan du starte med ladeboksen og tilføje vores gratis solcelleaftale.',
  easyUpgradeLater: 'Nem opgradering senere',
  easyUpgradeText: 'Hvis du senere vil tilføje en elaftale fra enkel, er det nemt. Du får automatisk adgang til:',
  smartChargeSave30: 'Saving Mode – spar op til 30% på opladning',
  spotNoMarkup: 'Spotpris uden tillæg',
  readyToBuy: 'Klar til at købe?',
  readyToBuySubtitle: 'Vælg din ladeboks – med eller uden installation',
  seeChargersWithoutPlan: 'Spørg om køb uden elaftale',

  // ============ Er enkel klar til 15-minutters afregning ============
  ready15minTitle: 'Er enkel klar til 15-minutters afregning?',
  ready15minSubtitle: 'Ja – vi er fuldt forberedt og Saving Mode udnytter det optimalt',
  ready15minIntro1: 'Ja, enkel energi er fuldt klar til 15-minutters afregning. Det betyder endnu bedre muligheder for at spare penge ved at optimere dit elforbrug og opladning til de helt rigtige tidspunkter.',
  ready15minIntro2: 'Med vores Saving Mode-prisgaranti betaler du altid for de billigste 15-minutters perioder i din ladeperiode.',
  what15minTitle: 'Hvad er 15-minutters afregning?',
  what15minSubtitle: 'Fra time-afregning til kvarter-afregning',
  what15minText1: '15-minutters afregning betyder, at din elpris opdateres hvert kvarter i stedet for hver time. Det giver mere præcis prissætning og større besparelsesmuligheder.',
  what15minText2: 'Med 15-minutters afregning kan du udnytte kortvarige prisfald, som ikke fanges ved time-afregning.',
  benefits15minTitle: 'Fordele ved 15-minutters afregning',
  benefit15min1Title: 'Større besparelser',
  benefit15min1Text: 'Udnyt kortvarige prisfald der ikke vises ved time-afregning.',
  benefit15min2Title: 'Mere præcis afregning',
  benefit15min2Text: 'Du betaler præcis for det du bruger, når du bruger det.',
  benefit15min3Title: 'Optimal Saving Mode',
  benefit15min3Text: 'Saving Mode kan optimere opladning endnu mere præcist.',
  benefit15min4Title: 'Bedre udnyttelse af sol og vind',
  benefit15min4Text: 'Fleksibelt forbrug matcher bedre den grønne produktion.',
  howSmartChargeUsesIt: 'Sådan bruger Saving Mode 15-minutters afregning',
  smartCharge15min1Title: 'Analyse af prisdata',
  smartCharge15min1Text: 'Saving Mode analyserer de kommende 15-minutters priser for at finde de billigste perioder i din ladeperiode.',
  smartCharge15min2Title: 'Prisgaranti',
  smartCharge15min2Text: 'Du afregnes til de præcise kvarterer med lavest pris – uanset hvornår bilen lader.',
  smartCharge15min3Title: 'Automatisk justering',
  smartCharge15min3Text: 'Hvis priserne ændrer sig, opdateres din prisgaranti automatisk.',
  smartCharge15min4Title: 'Maksimal besparelse',
  smartCharge15min4Text: 'Du betaler altid den lavest mulige pris for din opladning.',
  savingsExampleTitle: 'Eksempel på besparelse',
  savingsExampleIntro: 'Se hvordan 15-minutters afregning kan spare dig penge:',
  withoutSmartCharge: 'Uden Saving Mode',
  withoutSmartChargeExample: 'Du oplader kl. 18-22 når du kommer hjem. Prisen er høj fordi alle bruger strøm.',
  withSmartCharge: 'Med Saving Mode',
  withSmartChargeExample: 'Du betaler prisen for de billigste 15-minutters perioder i din ladeperiode – uanset hvornår bilen rent faktisk lader.',
  savingsResult: 'Resultat: Op til 30% lavere opladningsomkostninger',
  savingsResultNote: 'Faktisk besparelse afhænger af prisudvikling og dit forbrug.',
  requirementsTitle: 'Hvad kræver det?',
  requirement1Title: 'Smart elmåler',
  requirement1Text: 'De fleste danske husstande har allerede en smart elmåler der understøtter 15-minutters afregning.',
  requirement2Title: 'El-aftale med spotpris',
  requirement2Text: 'Din elaftale skal være baseret på spotpris for at drage fordel af 15-minutters afregning.',
  requirement3Title: 'Saving Mode (valgfrit)',
  requirement3Text: 'For automatisk optimering anbefaler vi Saving Mode, som er inkluderet i alle enkel elaftaler.',
  faq15min1Q: 'Hvornår træder 15-minutters afregning i kraft?',
  faq15min1A: '15-minutters afregning er allerede tilgængelig og enkel energi understøtter det fuldt ud.',
  faq15min2Q: 'Skal jeg gøre noget for at få 15-minutters afregning?',
  faq15min2A: 'Nej, som kunde hos enkel får du automatisk 15-minutters afregning når det er tilgængeligt i dit område.',
  faq15min3Q: 'Virker Saving Mode med 15-minutters afregning?',
  faq15min3A: 'Ja, Saving Mode er fuldt optimeret til 15-minutters afregning og udnytter de mest præcise prisdata.',
  faq15min4Q: 'Kan jeg se 15-minutters priser i appen?',
  faq15min4A: 'Ja, enkel appen viser priser kvarter for kvarter, så du altid ved hvad strømmen koster lige nu.',
  readyToSave15min: 'Klar til at spare med 15-minutters afregning?',
  readyToSave15minSubtitle: 'Skift til enkel og få automatisk de bedste priser',
  seePricesSubscriptions: 'Se priser og abonnementer',
  readSavingsOptions: 'Læs mere om Saving Mode',

  // ============ Hvor lang tid tager det at skifte ============
  switchTimeTitle: 'Hvor lang tid tager det at skifte?',
  switchTimeSubtitle: 'Vi håndterer hele skiftet – ofte med aktivering fra dag til dag',
  switchTimeIntro1: 'At skifte til enkel energi er hurtigt og nemt. Vi håndterer hele processen med dit nuværende elselskab, så du ikke behøver at gøre noget.',
  switchTimeIntro2: 'I de fleste tilfælde kan vi aktivere din nye aftale fra dag til dag, men den faktiske skiftedato afhænger af dit nuværende elselskabs opsigelsesperiode.',
  switchProcessTitle: 'Skifteprocessen trin for trin',
  switchProcessSubtitle: 'Sådan foregår skiftet til enkel energi',
  switchStep1Title: 'Du tilmelder dig',
  switchStep1Time: 'Ca. 2 minutter',
  switchStep1Text: 'Udfyld vores tilmeldingsformular med dine oplysninger. Det tager kun et par minutter.',
  switchStep2Title: 'Vi sender opsigelse',
  switchStep2Time: 'Inden for 24 timer',
  switchStep2Text: 'Vi sender automatisk opsigelse til dit nuværende elselskab og registrerer dig i DataHub.',
  switchStep3Title: 'Afvent opsigelsesperiode',
  switchStep3Time: 'Typisk 1-30 dage',
  switchStep3Text: 'De fleste elselskaber har 1-30 dages opsigelsesperiode. Nogle har ingen binding.',
  switchStep4Title: 'Din nye aftale starter',
  switchStep4Text: 'Din enkel-aftale aktiveres automatisk når opsigelsesperioden udløber. Du mærker ingen forskel i strømforsyningen.',
  importantInfoTitle: 'Vigtigt at vide',
  noInterruption: 'Ingen afbrydelse af strøm',
  noInterruptionText: 'Du har strøm hele tiden – der er ingen afbrydelse ved skift af elselskab.',
  weHandleCancellation: 'Vi håndterer opsigelsen',
  weHandleCancellationText: 'Du skal ikke selv kontakte dit nuværende elselskab – vi klarer det hele.',
  bindingPeriod: 'Tjek bindingsperiode',
  bindingPeriodText: 'Hvis du har binding hos dit nuværende elselskab, kan skiftet først ske når bindingen udløber.',
  fasterWithWaiver: 'Hurtigere med fraflytterattest',
  fasterWithWaiverText: 'Ved flytning eller særlige situationer kan skiftet gå hurtigere.',
  whatYouNeedTitle: 'Hvad skal du bruge?',
  requiredInfo: 'Påkrævede oplysninger',
  yourAddress: 'Din adresse',
  emailAndPhone: 'Email og telefonnummer',
  cprVerification: 'CPR-nummer (til verifikation)',
  optionalInfo: 'Valgfrie oplysninger',
  desiredSwitchDate: 'Ønsket skiftedato',
  estimatedConsumption: 'Estimeret årsforbrug',
  evChargerInfo: 'Info om elbil og ladeboks',
  faqSwitchTime1Q: 'Kan jeg skifte samme dag?',
  faqSwitchTime1A: 'I nogle tilfælde ja – særligt ved flytning eller hvis dit nuværende elselskab har dag-til-dag opsigelse. Kontakt os for at høre mere.',
  faqSwitchTime2Q: 'Hvad hvis jeg har binding hos mit nuværende elselskab?',
  faqSwitchTime2A: 'Skiftet kan først ske når bindingsperioden udløber. Vi registrerer dig i god tid, så skiftet sker automatisk når du er fri.',
  faqSwitchTime3Q: 'Mister jeg strøm under skiftet?',
  faqSwitchTime3A: 'Nej, du har strøm hele tiden. Skiftet sker elektronisk og påvirker ikke din strømforsyning.',
  faqSwitchTime4Q: 'Hvornår modtager jeg min første regning fra enkel?',
  faqSwitchTime4A: 'Din første regning kommer typisk 1-2 måneder efter din aftale er startet, afhængigt af hvilken afregningstype du har valgt.',
  readyToSwitch: 'Klar til at skifte?',
  readyToSwitchSubtitle: 'Tilmeld dig nu – vi klarer resten',
  signUpNow: 'Tilmeld dig nu',
  whoCanBeCustomer: 'Kan alle få strøm fra enkel?',
  readWhoCanBeCustomer: 'Læs om hvem der kan blive kunde',
  cancelWithOld: 'Skal jeg opsige hos mit nuværende elselskab?',
  weHandleIt: 'Vi håndterer opsigelsen for dig',

  // ============ Skal jeg opsige hos mit nuværende elselskab ============
  cancelOldTitle: 'Skal jeg opsige hos mit nuværende elselskab?',
  cancelOldSubtitle: 'Nej – vi håndterer opsigelsen for dig, så du slipper for besværet',
  cancelOldIntro1: 'Nej, du skal ikke selv kontakte dit nuværende elselskab. Når du tilmelder dig hos enkel energi, håndterer vi hele processen for dig.',
  cancelOldIntro2: 'Vi sender opsigelsen, koordinerer med DataHub, og sørger for en smidig overgang – uden afbrydelse af din strømforsyning.',
  weDoForYou: 'Det gør vi for dig',
  sendCancellation: 'Sender opsigelse til dit gamle elselskab',
  coordinateGrid: 'Koordinerer med netselskab og DataHub',
  handleCommunication: 'Håndterer al kommunikation',
  ensureSmoothTransition: 'Sikrer smidig overgang uden strømafbrydelse',
  keepDuUpdated: 'Holder dig opdateret undervejs',
  duShouldNot: 'Det skal du IKKE gøre',
  contactOldCompany: 'Kontakte dit gamle elselskab',
  sendCancellationSelf: 'Sende opsigelse selv',
  worryAboutDetails: 'Bekymre dig om detaljer',
  contactGridCompany: 'Kontakte netselskabet',
  cancelBeforeSignup: 'Opsige før du har tilmeldt dig hos os',
  importantAboutCurrent: 'Vigtigt om dit nuværende elselskab',
  importantAboutCurrentText: 'Selvom vi håndterer opsigelsen, er det godt at kende dine nuværende vilkår:',
  noticePeriod: 'Opsigelsesperiode',
  noticePeriodText: 'De fleste elselskaber har 1-30 dages opsigelse. Tjek dine vilkår for at vide hvornår skiftet kan ske.',
  bindingPeriodTextCancel: 'Har du binding, kan skiftet først ske når den udløber. Vi registrerer dig i god tid.',
  terminationFees: 'Ophørsgebyrer',
  terminationFeesText: 'Nogle elselskaber opkræver et ophørsgebyr. Tjek dine vilkår eller kontakt dem for at høre nærmere.',
  howItWorks: 'Sådan foregår det',
  process1Title: 'Du tilmelder dig hos enkel',
  process1Text: 'Udfyld vores tilmeldingsformular – det tager kun 2 minutter.',
  process2Title: 'Vi sender opsigelse',
  process2Text: 'Vi kontakter dit gamle elselskab og registrerer skiftet i DataHub.',
  process3Title: 'Skiftet sker automatisk',
  process3Text: 'Når opsigelsesperioden er overstået, starter din enkel-aftale automatisk.',
  legalProtection: 'Din juridiske beskyttelse',
  legalProtectionText: 'Som forbruger er du beskyttet af elforsyningsloven:',
  noInterruptionLaw: 'Ingen strømafbrydelse:',
  noInterruptionLawText: 'Du har ret til uafbrudt strømforsyning under skiftet.',
  clearProcedure: 'Klar procedure:',
  clearProcedureText: 'Alle elselskaber skal følge samme standardproces for leverandørskift.',
  withdrawalRight: 'Fortrydelsesret:',
  withdrawalRightText: 'Du har 14 dages fortrydelsesret på din nye aftale.',
  protectionAgainstFees: 'Beskyttelse mod urimelige gebyrer:',
  protectionAgainstFeesText: 'Elselskaber må ikke opkræve urimelige gebyrer ved skift.',
  whatHappensToYourBill: 'Hvad sker der med dine regninger?',
  fromOldCompany: 'Fra dit gamle elselskab',
  fromOldCompanyText: 'Du modtager en slutafregning fra dit gamle elselskab der dækker perioden frem til skiftet.',
  meterReadingFromSwitchDate: 'Måleraflæsning fra skiftedato',
  acontoBalanceSettled: 'Eventuel aconto-saldo afregnes',
  taxRefundInfo: 'Elafgift refunderes for den resterende periode',
  fromEnkelEnergi: 'Fra enkel energi',
  fromEnkelEnergiText: 'Din første regning fra os dækker perioden fra skiftedato og frem.',
  monthlyOrQuarterly: 'Månedlig eller kvartalsvis afregning',
  autoAcontoPay: 'Automatisk acontobetaling',
  visibleInApp: 'Alt synligt i enkel appen',
  faqCancel1Q: 'Hvad hvis jeg ved et uheld opsiger selv først?',
  faqCancel1A: 'Kontakt os med det samme, så koordinerer vi med dit gamle elselskab for at sikre en smidig overgang.',
  faqCancel2Q: 'Kan jeg få hurtigere skift hvis jeg selv opsiger?',
  faqCancel2A: 'Nej, skiftet går ikke hurtigere ved at du selv opsiger. Lad os håndtere det – så er du sikker på at alt foregår korrekt.',
  faqCancel3Q: 'Hvad hvis mit gamle elselskab protesterer?',
  faqCancel3A: 'Det sker meget sjældent. Hvis der skulle opstå problemer, håndterer vi kommunikationen og holder dig orienteret.',
  faqCancel4Q: 'Skal jeg betale dobbelt under skiftet?',
  faqCancel4A: 'Nej, du betaler kun til ét elselskab ad gangen. Dit gamle elselskab stopper med at fakturere dig fra skiftedatoen.',
  readyToSwitchCancel: 'Klar til at skifte?',
  readyToSwitchCancelSubtitle: 'Vi håndterer det hele – du skal bare tilmelde dig',
  howLongToSwitch: 'Hvor lang tid tager det at skifte?',
  readAboutSwitchProcess: 'Læs om skifteprocessen',
  seeIfYouCanBeCustomer: 'Læs om hvem der kan blive kunde',

  // ============ Hvilken ladeboks skal jeg vælge ============
  whichChargerTitle: 'Hvilken ladeboks skal jeg vælge?',
  whichChargerSubtitle: 'Sammenlign ladebokse fra Zaptec og NexBlue – find den perfekte til dig',
  whichChargerIntro1: 'Vi tilbyder ladebokse fra Zaptec og NexBlue, der alle er udvalgt for kvalitet, driftssikkerhed og kompatibilitet med enkel Saving Mode.',
  whichChargerIntro2: 'Nedenfor kan du se en hurtig guide og detaljeret sammenligning, så du kan vælge den ladeboks der passer bedst til dine behov.',
  quickDecisionGuide: 'Hurtig beslutningsguide',
  bestPrice: 'Bedste pris',
  ifBudgetMatters: 'Hvis pris er vigtigst',
  mostPopular: 'Mest populær',
  bestBalanceOfAll: 'Bedste balance mellem pris, features og robusthed',
  premiumChoice: 'Premium valg',
  newestTechnology: 'Nyeste teknologi og fremtidssikring',
  chargerComparison: 'Sammenligning af ladebokse',
  function: 'Funktion',
  maxChargePower: 'Max. ladeeffekt',
  connection: 'Forbindelse',
  loadBalancing: 'Load balancing',
  rfidAccess: 'RFID-adgang',
  warranty: 'Garanti',
  priceFrom: 'Pris fra',
  whatToConsider: 'Hvad skal du overveje?',
  budgetTitle: 'Budget',
  budgetText: 'NexBlue Edge 2 er vores mest prisvenlige ladeboks og giver dig premium-kvalitet til en skarp pris.',
  budgetNote: 'Anbefaling: NexBlue Edge 2 hvis budget er afgørende.',
  robustnessTitle: 'Robusthed',
  robustnessText: 'Zaptec Go er kendt for sin ekstreme holdbarhed og har bevist sig i det skandinaviske klima.',
  robustnessNote: 'Anbefaling: Zaptec Go hvis du prioriterer lang levetid.',
  connectivityTitle: 'Forbindelse',
  connectivityText: 'Zaptec-modellerne har både Wi-Fi og 4G, så de virker selvom dit Wi-Fi er ustabilt. NexBlue bruger Wi-Fi + Bluetooth.',
  connectivityNote: 'Anbefaling: Zaptec hvis du har ustabilt Wi-Fi.',
  futureProofingTitle: 'Fremtidssikring',
  futureProofingText: 'Zaptec Go 2 har V2G-klar hardware, så du er klar når Vehicle-to-Grid bliver tilgængeligt.',
  futureProofingNote: 'Anbefaling: Zaptec Go 2 hvis du vil være helt fremtidssikret.',
  ourRecommendations: 'Vores anbefalinger',
  familyEconomy: 'Familien med stram økonomi',
  familyEconomyRec: 'NexBlue Edge 2',
  familyEconomyText: 'Får du mest for pengene med NexBlue Edge 2 – premium kvalitet til skarp pris.',
  experiencedEvOwner: 'Den erfarne elbilejer',
  experiencedEvOwnerRec: 'Zaptec Go',
  experiencedEvOwnerText: 'Den mest populære ladeboks i Skandinavien – bevist kvalitet og pålidelighed.',
  premiumSegment: 'Premium segmentet',
  premiumSegmentRec: 'Zaptec Go 2',
  premiumSegmentText: 'Nyeste teknologi med V2G-klar hardware – helt fremtidssikret.',
  unstableWifi: 'Ustabilt Wi-Fi',
  unstableWifiRec: 'Zaptec Go eller Go 2',
  unstableWifiText: 'Med 4G backup er du sikker på at Saving Mode altid virker.',
  stillUnsure: 'Stadig i tvivl?',
  stillUnsureSubtitle: 'Ring til os – vi hjælper dig med at vælge den rigtige ladeboks',
  callUs: 'Ring til os:',
  seeAllPackages: 'Se alle pakker',

  // ============ Virker enkel med alle ladebokse (worksWithAllChargers) ============
  // These are used in pages/Virker-enkel-med-alle-ladebokse.js with t('worksWithAllChargers.xxx')
};